export const meta = { id: 'O10', slug: 'criar-descritores', title: 'Como criar Descritores', description: 'Escreva descritores comportamentais claros para diferenciar os níveis de uma Competência.', profile: 'owner', category: 'metodologia', type: 'task', status: 'published', order: 400, keywords: ['descritores','comportamento','níveis','competência'], previous: 'O09', next: 'O11', related: ['O08','O09','A02'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como criar Descritores

Descritores transformam níveis abstratos em referências comportamentais observáveis.

<HelpImage pendingId="O09.2" alt="Criação ou edição de descritor comportamental" />

## Um bom descritor deve ser

- observável;
- específico;
- compreensível;
- coerente com a Competência;
- claramente diferente dos níveis vizinhos.

<Callout type="tip">Prefira descrever o que a pessoa faz e demonstra. Evite descrições vagas como “bom” ou “excelente” sem evidência comportamental.</Callout>
